import sticky from './_sticky';

export function stickySidebar() {
  const sidebarLibrary = document.querySelector('.sticky-sidebar-library');
  if(sidebarLibrary) {
    new sticky(sidebarLibrary, {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: '.sticky-container',
      minWidth: 1439
    });
  }
  const sidebarNews = document.querySelector('.sticky-sidebar-news');
  if(sidebarNews) {
    new sticky(sidebarNews, {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: '.sticky-container',
      minWidth: 1023
    });
  }
}